import BettingContainer from '@/components/BettingContainer';
import Footer from '@/components/common/Footer';
import Sidebar from '@/components/common/Sidebar';
import Header from '@/components/Header';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const GameLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div>
      <Header onMenuClick={() => setIsSidebarOpen(true)} />

      <div className="flex xl:mt-1 xl:pr-[5px]">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />

        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
        <BettingContainer />
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default GameLayout;
